import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { first, map } from 'rxjs';

import { environment } from '@environment';

import { Result } from '@common/types/http-types';
import { User } from './users/user.model';
import { AccountService } from './account.service';

/**
 * Workaround to get the user before rendering the page
 * @constructor
 */
export const UserGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const $account = inject(AccountService);
  return http.get<Result<User>>(`${environment.baseUrl}/v1/user`).pipe(
    map(res => {
      $account.user.set(res.data);
      return true;
    }),
    first()
  );
};
